const quotationChat = {
  quotationChatNavLabel: "แชทการแจ้งเตือน", // translated 
  quotationChatApprovalTitle: "แชทการแจ้งเตือน", // translated 
  quotationChatAccountNotApprovedTitle: "บัญชียังไม่ได้", // translated 
  quotationChatAccountNotApprovedDescription:
    "ยังไม่สามารถตรวจสอบระบบการจัดการเพื่อข้อมูลเพิ่มเติม", // translated 
  quotationChatViewAiChat: "ดู A.I.", // translated 

  quotationRequestChatSessions: "ชิบอบ", // translated 
  quotationRequestChatNoPastSessions: "ไม่มีการอัพเดทก่อน", // translated 
  quotationRequestChatNewChat: "คนใหม่", // translated 
  quotationRequestChatCloseSidebar: "ปิดระบบชั่วคราว", // translated 
  quotationRequestChatSessionFallback: "ชิบอบ", // translated 
  quotationRequestChatDefaultSessionName: "แชทแชทใหม่", // translated 
  quotationRequestChatTitle: "สงสัยเรื่องนั้น", // translated 
  quotationRequestChatResponseLanguageLabel: "ภาษาตอบกลับ", // translated 
  quotationRequestChatOpenSidebar: "ในช่วงเวลานี้", // translated 
  quotationRequestChatRenameSession: "เปลี่ยนชื่อ", // translated 
  quotationRequestChatDeleteSession: "ลช", // translated 
  quotationRequestChatToggleDarkMode: "โหมดมืดมืด", // translated 
  quotationRequestChatSwitchToLightMode: "เปลี่ยนเป็นโหมดสว่าง", // translated 
  quotationRequestChatSwitchToDarkMode: "เปลี่ยนเป็นโหมดมืด", // translated 
  quotationRequestChatEmptyStateHeading: "เริ่มต้นประกาศใหม่อีกครั้ง", // translated 
  quotationRequestChatEmptyStateSubheading:
    "อธิบายข้อเรียกร้องของคุณแล้วฉันจะสร้างคำขอให้คุณทราบ", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "พิมพ์ข้อความของคุณเพื่อเริ่มดำเนินการ... (Shift+Enter สำหรับบรรทัดใหม่)", // translated 
  quotationRequestChatMessagePlaceholder: "พิมพ์ข้อความของคุณ... (Shift+Enter สำหรับบรรทัดใหม่)", // translated 
  quotationRequestChatUploadFile: "นั่นไฟล์", // translated 
  quotationRequestChatUploadAttachment: "เรื่องไฟล์แนบ", // translated 

  quotationRequestChatStopGenerating: "กำลังดำเนินการ", // translated 
  quotationRequestChatGenerateQuotation: "สร้างเลย", // translated 
  quotationRequestChatGenerateFinalQuotation: "สร้างป้อมปราการ", // translated 
  quotationRequestChatFinalizeQuotationRequest: "ไม่ต้องสงสัยเลย", // translated 
  quotationRequestChatHoldToRecord: "กดค้างเพื่อบันทึกข้อความเสียง", // translated 
  quotationRequestChatRecordingReleaseToSend: "เรียนรู้บันทึกปล่อยเพื่อส่ง", // translated 
  quotationRequestChatRecording: "ติดตามบันทึก...", // translated 
  quotationRequestChatSelectSessionFirst: "ในเวลาเดียวกันนั้นแชทก่อน", // translated 
  quotationRequestChatCancelVoiceRecording: "ฮีโร่", // translated 
  quotationRequestChatListening: "การเล่น...", // translated 
  quotationRequestChatTranscribing: "ไม่ต้องถอดความ...", // translated 

  quotationRequestChatFileUploadedSuccess: "ในที่สุดไฟล์สำเร็จ", // translated 
  quotationRequestChatFailedCreateSession: "สร้างแชทไม่สำเร็จลองอีกครั้ง", // translated 
  quotationRequestChatFailedUploadFile: "สุดท้ายไฟล์ไม่สำเร็จเพียงแค่ลองอีกครั้ง", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "คำอธิบายที่ค้างอยู่ก่อนส่งข้อความอื่น", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "คำอธิบายที่จะระงับอยู่ก่อนที่จะสรุปคำขอเกี่ยวกับ", // translated 
  quotationRequestChatFavoriteMarked: "และเริ่มแชทเป็นสิ่งที่แล้ว", // translated 
  quotationRequestChatFavoriteUnmarked: "การรับรู้ถึงการแชทเป็นสิ่งที่แล้ว", // translated 
  quotationRequestChatFailedSetFavorite: "จะเริ่มไม่สำเร็จ", // translated 
  quotationRequestChatFailedUnsetFavorite: "ยกเลิกอย่างเดียวไม่สำเร็จ", // translated 
  quotationRequestChatRenamedSuccess: "เปลี่ยนชื่อแชทสำเร็จ", // translated 
  quotationRequestChatFailedRename: "เปลี่ยนชื่อแชทไม่สำเร็จลองอีกครั้ง", // translated 
  quotationRequestChatDeletedSuccess: "สำเร็จในแชทสำเร็จ", // translated 
  quotationRequestChatFailedDelete: "ทำอย่างไรให้แชทไม่สำเร็จลองอีกครั้ง", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "ลิ้งไฟล์แนบสำเร็จ", // translated 
  quotationRequestChatFailedDeleteAttachment: "ลบไฟล์แนบไม่สำเร็จลองอีกครั้ง", // translated 
  quotationRequestChatSubmittedSuccess:
    "อ้างถึงความสำเร็จ! คำขอของคุณกำลังถูกดำเนินการ", // translated 
  quotationRequestChatFailedSubmit: "อ้างว่าไม่สำเร็จ", // translated 
  quotationChatPdfDownloadedSuccess: "ดาวน์โหลด PDF สำเร็จ!", // translated 
  quotationChatFailedGeneratePdf: "สร้าง PDF ไม่สำเร็จ", // translated 

  quotationRequestChatSubagentRequired:
    "ผู้ใช้ซับเอเจนต์ก่อนส่งคำขอเป็นเจ้าของ", // translated 
  quotationRequestChatAppUserLoading:
    "โปรไฟล์ผู้ใช้ CRM ของคุณกำลังโหลดลองอีกครั้งอีกครั้งคลิก", // translated 
  quotationRequestChatAppUserMismatch:
    "โปรไฟล์ผู้ใช้ CRM ของคุณไม่อัปเดตแชทนี้", // translated 

  quotationRequestChatRenameTitle: "เปลี่ยนชื่อแชท", // translated 
  quotationRequestChatSessionName: "ชื่อเต้", // translated 
  quotationRequestChatEnterSessionName: "ใส่ชื่อป้อมปราการ", // translated 
  quotationRequestChatSaving: "ติดตามบันทึก...", // translated 
  quotationRequestChatSave: "บันทึก", // translated 
  quotationRequestChatDeleteTitle: "หลบวิดีโอแชท", // translated 
  quotationRequestChatDeleteConfirm: "คุณไม่จำเป็นว่าต้องการลบแชทนี้ใช่ไหม?", // translated 
  quotationRequestChatDeleteCannotUndo: "การดำเนินการนี้สามารถยกเลิกได้", // translated 
  quotationRequestChatDeleting: "การเล่นสเก็ต...", // translated 
  quotationRequestChatDelete: "เล", // translated 

  quotationRequestChatAttachmentsTitle: "แนบแชทเกี่ยวกับเรื่องนี้", // translated 
  quotationRequestChatLoadingAttachments: "ให้โหลดไฟล์แนบ...", // translated 
  quotationRequestChatNoAttachments: "ไม่พบไฟล์แนบ", // translated 
  quotationRequestChatDeleteAttachment: "ค่าใช้จ่าย", // translated 
  quotationRequestChatUploadingAttachment: "เรื่องของไฟล์แนบ...", // translated 
  quotationRequestChatUploadingAttachmentWait: "รอสักครู่เพื่อดาวน์โหลดไฟล์ของคุณกำลังดำเนินการ", // translated 

  quotationRequestChatAnswerPendingQuestions: "คำตอบที่จะคงอยู่", // translated 
  quotationRequestChatProposeOwnAnswer: "เสนอคำตอบของฉันเอง", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "พิมพ์คำตอบอัตโนมัติ...", // translated 
  quotationRequestChatAnsweredOfTotal: "แล้ว {{answered}} จาก {{total}}", // translated 
  quotationRequestChatReadyToSubmit: "พร้อมส่ง", // translated 
  quotationRequestChatSubmitAll: "ส่งทั้งหมด", // translated 
  quotationRequestChatRespondToOneQuestion: "{{count}} ได้", // translated 
  quotationRequestChatRespondToManyQuestions: "{{count}} ได้", // translated 

  quotationRequestChatFinalizeTitle: "ไม่ต้องสงสัยเลย", // translated 
  quotationRequestChatLoadingSessionData: "ให้โหลดข้อมูล...", // translated 
  quotationRequestChatErrorLoadingSession: "ทำให้เกิดการโหลดข้อมูลอีกครั้งลองอีกครั้ง", // translated 
  quotationRequestChatQuotationTitle: "ชื่อเรื่อง", // translated 
  quotationRequestChatExtraComments: "เพิ่มเติม", // translated 
  quotationRequestChatSubmitting: "กระโดดข้าม...", // translated 
  quotationRequestChatSubmit: "ส่ง", // translated 
  quotationRequestChatSubmittingOverlayTitle: "ส่งคำถามเกี่ยวกับ...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "โปรดรอสักครู่เพื่อเรียกร้องความสนใจของคุณ", // translated 

  quotationRequestChatSelectSubagent: "เลือกซับเอเจนต์", // translated 
  quotationRequestChatSearchSubagents: "ค้นหาซับเอเจนต์...", // translated 
  quotationRequestChatLoadingSubagents: "ลองโหลดซับเอเจนต์...", // translated 
  quotationRequestChatNoSubagentsFound: "ไม่พบซับเอเจนต์", // translated 
  quotationRequestChatNoSubagentsAvailable: "ไม่มีซับเจนต์ที่ใช้ได้", // translated 
  quotationRequestChatSelectedSubagent: "เลือกแล้ว: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "ผู้ใช้ซับเอเจนต์", // translated 
  quotationRequestChatSearchUsers: "ค้นหาผู้ใช้...", // translated 
  quotationRequestChatNoUsersFound: "ไม่พบผู้ใช้", // translated 
  quotationRequestChatNoUsersAvailable: "ไม่มีผู้ใช้ได้", // translated 

  quotationChatDownloadSummaryTitle: "สรุปเรื่องของคุณ", // translated 
  quotationChatDownloadSummaryDescription:
    "รายละเอียดของคุณด้านล่างเพื่อสรุป PDF ส่วนบุคคลของการเดินทาง PDF จะรวมรายละเอียดการเดินทางเพื่อดูข้อมูลการแพทย์และกำหนดการรายวัน", // translated 
  quotationChatCustomerTitle: "ทาสหน้า", // translated 
  quotationChatSelectTitle: "เลือกคำนำหน้า", // translated 
  quotationChatHonorificMr: "นาย", // translated 
  quotationChatHonorificMrs: "นาง", // translated 
  quotationChatHonorificMs: "นางสาว", // translated 
  quotationChatHonorificDr: "ดร.", // translated 
  quotationChatHonorificProf: "ศาสตราจารย์", // translated 
  quotationChatCustomerPhone: "โทรศัพท์", // translated 
  quotationChatCustomerCompany: "บริษัท", // translated 
  quotationChatCustomerMessage: "กุญแจ", // translated 
  quotationChatCustomerCountry: "ประเทศ", // translated 
  quotationChatGenerating: "เพื่อสร้าง...", // translated 
  quotationChatDownloadPdf: "ดาวน์โหลด PDF", // translated 

  quotationChatTripSummary: "ยังไงก็จ", // translated 
  quotationChatDownloadAsPdf: "ดาวน์โหลดเป็น PDF", // translated 
  quotationChatNoTripSummary: "ไม่มีสรุปความสำเร็จสำหรับสิ่งนี้", // translated 

  quotationRequestChatThinking: "การเล่นความคิด...", // translated 
  quotationRequestChatSources: "ระบบ", // translated 
  quotationRequestChatSearchingWebFor: 'ค้นหาเว็บ: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "บริการที่บริษัททัวร์ออเปอเรเตอร์", // translated 
  quotationRequestChatServicesByCustomer: "บริการที่ลูกค้าจัดการเอง", // translated 
  quotationRequestChatReadyNotice:
    "เราจะแจ้งเรื่องนี้เพื่อขอทราบในวันนี้", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "สร้างป้อมปราการ", // translated 

  quotationRequestChatMaybeYouWantToAsk: "ถาม:", // translated 
  quotationRequestChatClickToSendSuggestion: "คลิกเพื่อส่งข้อความนี้", // translated 

  quotationRequestChatAddToFavorites: "อยู่ในนั้น", // translated 
  quotationRequestChatRemoveFromFavorites: "หลบออกมาจากนั้น", // translated 
  quotationRequestChatSubmitted: "ส่ง", // translated 

  quotationRequestChatQuotationRequest: "อ้างถึง: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{ชื่อ}}", // translated 
  quotationRequestChatQuotationTooltipStatus: " - สถานะ: {{status}}", // translated 

  quotationChatLoading: "โหลด...", // translated 
  quotationChatSessionNotFound: "ไม่พบแชทสำหรับสิ่งนี้", // translated 
  quotationChatMemberSessionNotFound: "ไม่พบข้อมูลสมาชิกสำหรับเรื่องนี้", // translated 
  quotationChatUnableToConnect: "เราสามารถแชทได้", // translated 
  quotationChatConnecting: "ที่จะ...", // translated 
  quotationChatTypeYourMessage: "พิมพ์ข้อความของคุณ...", // translated 
  quotationChatConnected: "แล้ว", // translated 
  quotationChatConnectingStatus: "ที่จะ...", // translated 
  quotationChatDisconnected: "ตัดเงื่อนไข", // translated 
};


export default quotationChat;
